import axios from "axios";
import { getAccessToken } from "../services/cookieService";
import { handle403Redirect } from "utils/authHandlers";
import { environment } from "../environments/environment";

const BASE_URL = environment.PRODUCT_BRIDGE_HOST_URL;
const version = environment.PRODUCT_BRIDGE_API_VERSION;

export const productBridgeInterceptor = axios.create({
  baseURL: `${BASE_URL}/${version}`,
  headers: {
    "Content-Type": "application/json",
    service: "ecomm",
  },
});

// Interceptor to add x-token header
productBridgeInterceptor.interceptors.request.use(
  (config) => {
    const token = getAccessToken();
    if (token) {
      config.headers["x-token"] = token;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Interceptor to handle response errors
productBridgeInterceptor.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 403) {
      handle403Redirect();
    }
    return Promise.reject(error);
  }
);

export default productBridgeInterceptor;
